import React, { useEffect, useMemo } from "react";
import "./Banner.sass";
import { useSelector, useDispatch } from "react-redux";
import { fetchBanners } from "../../redux/actions/fetchBannersAction";
import { useLocation } from "react-router-dom";

function pickRandomBanner(banners, currentPage, placement) {
  // Step 1: Only published banners
  const eligible = banners.filter((banner) => banner.published === "1");

  // Step 2: Find banners with matching display rule
  const weightedBanners = eligible
    .map((banner) => {
      const matchingRule = banner.display_rules.find((rule) => {
        const correctPlacement = rule.position === placement || (rule.position === "both" && (placement === "bottom" || placement === "top"));
        if (correctPlacement) {
          try {
            const regex = new RegExp(rule.url);

            return regex.test(currentPage) && correctPlacement;
          } catch {
            return rule.url === currentPage && correctPlacement;
          }
        }
      });
      return matchingRule ? { ...banner, weight: matchingRule.weight } : null;
    })
    .filter(Boolean); // Remove nulls

  console.log("Weighted Banners:", weightedBanners);
  if (weightedBanners.length === 0) return null;

  // Step 3: Weighted random selection
  const totalWeight = weightedBanners.reduce((sum, b) => sum + (b.weight || 0), 0);
  let random = Math.random() * totalWeight;

  for (const banner of weightedBanners) {
    if (random <= banner.weight) {
      console.log("Selected Banner:", banner);
      return banner;
    }
    random -= banner.weight;
  }

  // Fallback: Return first eligible banner if random selection fails
  return weightedBanners[0] || null;
}

export default function Banner({ placement = "top" }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { bannersResult, loading, error } = useSelector((state) => state.fetchBanners);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  useEffect(() => {
    console.log("URL changed to:", location.pathname);
  }, [location]);

  const selectedBanner = useMemo(() => {
    return pickRandomBanner(
      bannersResult,
      location.pathname,
      placement
    );
  }, [bannersResult, location.pathname, placement]);
  
  if (loading) {
    console.log("Loading banners...");
    return <></>;
  }

  if (error) {
    console.error("Error fetching banners:", error);
    return <></>;
  }

  if (!bannersResult || bannersResult.length === 0) {
    return null;
  }


  return (
    <>
      {selectedBanner && (
        <div
          className={`banner-wrapper${placement ? ` banner-${placement}` : ""}`}
          style={{
            backgroundColor: selectedBanner.background_color || "transparent",
            backgroundImage: selectedBanner.background_image
              ? `url(${selectedBanner.background_image})`
              : "none",
          }}
        >
          <div className="banner-container">
            <a
              href={selectedBanner.click_thru || selectedBanner.node_url}
              target={selectedBanner.target || "_self"}
              rel="noopener noreferrer"
            >
              {/* Desktop image */}
              {selectedBanner.desktop_image && (
                <img
                  className="banner-desktop"
                  src={selectedBanner.desktop_image}
                  alt={selectedBanner.title || "Banner"}
                />
              )}

              {/* Mobile image */}
              {selectedBanner.mobile_image && (
                <img
                  className="banner-mobile"
                  src={selectedBanner.mobile_image}
                  alt={selectedBanner.title || "Banner"}
                />
              )}
            </a>
          </div>
        </div>
      )}
    </>
  );
}


// [
//   {
//     nid: "434",
//     title: "Testbanner2",
//     type: "banner",
//     published: "1",
//     node_url: "/node/434",
//     background_color: null,
//     background_image: null,
//     click_thru: "https://google.com",
//     desktop_image:
//       "//contentuat.choose.physio/sites/default/files/2025-08/TRADIES_CHOOSE_742X120.jpg",
//     display_rules: [
//       {
//         url: "/what-is-physio",
//         position: "bottom",
//         weight: 100,
//       },
//       {
//         url: "/your-condition",
//         position: "top",
//         weight: 100,
//       },
//     ],
//     mobile_image: null,
//     start_date: "2025-08-22T10:58:18+10:00",
//     stop_date: "2025-09-05T10:58:18+10:00",
//     target: "_blank",
//   },
// ];


